export default "__VITE_ASSET__WM5h3$M8__"